import { FC } from "react";
import { Switch } from "@/components/Base/Switch";
import { Icon } from "@/components/Common/Icon";
import { useTerminologyReplacer } from "@/hooks/useTerminologyReplacer";
import { TerminologyOptions } from "@/types/v2";

export interface ShowAllRepairOrdersToggleProps {
  showAllRepairOrders: boolean;
  onToggleChange: (show: boolean) => void;
  isLayoutSelected: boolean;
  disabled?: boolean;
  className?: string;
}

export const ShowAllRepairOrdersToggle: FC<ShowAllRepairOrdersToggleProps> = ({
  showAllRepairOrders,
  onToggleChange,
  isLayoutSelected,
  disabled = false,
  className = "",
}) => {
  const { terminolize } = useTerminologyReplacer();

  // Only show the toggle when a layout is selected (layout filtering is active)
  if (!isLayoutSelected) {
    return null;
  }

  const repairOrderTerm = terminolize(
    "Repair Orders",
    TerminologyOptions.repairOrder,
    "plural"
  );

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Icon
        name="list"
        size={14}
        className={
          showAllRepairOrders
            ? "text-accent-foreground"
            : "text-muted-foreground"
        }
      />
      <span className="hidden text-sm text-white/70 sm:inline">
        Layout {repairOrderTerm}
      </span>
      <span className="text-sm text-white/70 sm:hidden">Show all</span>
      <Switch
        checked={showAllRepairOrders}
        onCheckedChange={onToggleChange}
        disabled={disabled}
      />
      <span className="hidden text-sm text-white/70 sm:inline">
        All {repairOrderTerm}
      </span>
    </div>
  );
};
